module.exports = __webpack_public_path__ + "static/img/album01_3.44818dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/album01/album01_3.png
// module id = A5K2
// module chunks = 1